import { render, staticRenderFns } from "./IconVentilatie.vue?vue&type=template&id=581c6e98&scoped=true"
import script from "./IconVentilatie.vue?vue&type=script&lang=ts"
export * from "./IconVentilatie.vue?vue&type=script&lang=ts"
import style0 from "./IconVentilatie.vue?vue&type=style&index=0&id=581c6e98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581c6e98",
  null
  
)

export default component.exports